import * as actionTypes from './actionTypes';
import axios from "axios";
import api from '../../utilities/api';
import { getMessage } from '../../utilities/getMessage';

export const getByMatchCount=({
    matchCollectionId,
    betMatchCount
},token)=>async dispatch=>{
    dispatch({
        type:actionTypes.GET_PATTERN_BY_MATCH_COUNT_START,
    })
    const options={
        url:`${api}/betpatterns/${matchCollectionId}/betMatchCount/${betMatchCount}`,
        method:'GET',
        headers:{
            'Authorization':`Bearer ${token}`
        },
        data:{}
    }
    await axios(options)
            .then(response=>dispatch({
                type:actionTypes.GET_PATTERN_BY_MATCH_COUNT_SUCCESS,
                payload:response.data
            }))
            .catch(error=>dispatch({
                type:actionTypes.GET_PATTERN_BY_MATCH_COUNT_FAIL,
                payload:getMessage(error)
            }))
}